/**
 * Interval for checking whether a focus trap has tabbable nodes, allowing
 * a dialog or drawer to open with the trap activated
 */
export const FOCUS_TRAP_CHECK_INTERVAL = 10;
/**
 * A timeout will run at this point if the interval-based check (above) hasn't
 * found tabbable nodes for a trap to activate. The timeout will clear the
 * interval check and `resolve` the `checkCanFocusTrap` callback's `Promise`
 **/
export const FOCUS_TRAP_TIMEOUT_FALLBACK = FOCUS_TRAP_CHECK_INTERVAL * 20;
